import qs from 'qs';

export function getPageQueriesFromPath(location) {
  return qs.parse(location.search.replace('?', '') || (location.hash && location.hash.includes('?') ? location.hash.replace(/#.*\?/, '') : ''));
}